var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHolidayItinerary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000175302076602388582390000005954120249068507065_);}\n\t.st2{fill:url(#SVGID_00000080908158416723325860000005940408168313417919_);}\n\t.st3{fill:url(#SVGID_00000147179149890429572680000016324606139576657551_);}\n\t.st4{fill:url(#SVGID_00000153678000767655674920000017106375382461698218_);}\n\t.st5{fill:url(#SVGID_00000137114170784372554740000012912538486806177944_);}\n\t.st6{fill:url(#SVGID_00000000945654895904849390000005332097696832329111_);}\n\t.st7{fill:url(#SVGID_00000056424957157738940130000007222402488607412358_);}\n\t.st8{fill:url(#SVGID_00000029748370198656119460000009932968416466263487_);}\n\t.st9{fill:url(#SVGID_00000127023610564522843670000016432635184114000017_);}\n\t.st10{fill:url(#SVGID_00000179633062593824253430000010392403052811613568_);}\n\t.st11{fill:url(#SVGID_00000157296445738318737160000010280906498474460581_);}\n\t.st12{fill:url(#SVGID_00000119088416486119017140000009770257177607717008_);}\n\t.st13{fill:url(#SVGID_00000170277450180841336600000017044477750444251023_);}\n\t.st14{fill:url(#SVGID_00000052795466465030265190000010696294231835736486_);}\n\t.st15{fill:url(#SVGID_00000035511825537180972670000005364151346427493043_);}\n\t.st16{fill:url(#SVGID_00000180367619053133050090000010572712450518598020_);}\n\t.st17{fill:url(#SVGID_00000009584625042371445860000008182410110934784428_);}\n\t.st18{fill:url(#SVGID_00000122707861157782638900000004856417335360884903_);}\n\t.st19{fill:url(#SVGID_00000126319531904616559870000016381783593036257210_);}\n\t.st20{fill:url(#SVGID_00000118362122917578597220000003424637340676907911_);}\n\t.st21{fill:url(#SVGID_00000098937121008975942250000000473098965156967831_);}\n\t.st22{fill:url(#SVGID_00000081634986316572950240000017099010886841872056_);}\n\t.st23{fill:url(#SVGID_00000176035046788537733190000005415580600854591400_);}\n\t.st24{fill:url(#SVGID_00000078021273907439657470000013654640345518320524_);}\n\t.st25{fill:url(#SVGID_00000078759189745467345920000007336575214415752869_);}\n\t.st26{fill:url(#SVGID_00000031183945653050163600000008131623043822300600_);}\n\t.st27{fill:url(#SVGID_00000134962963979028032360000009267762242304349352_);}\n\t.st28{fill:url(#SVGID_00000178895396145744252390000015323667877496812420_);}\n\t.st29{fill:url(#SVGID_00000177471816969008584050000006256662029954235012_);}\n\t.st30{fill:url(#SVGID_00000150062597497043585490000016122676607957395864_);}\n\t.st31{fill:url(#SVGID_00000085970383652621744060000004525953378729079201_);}\n\t.st32{fill:url(#SVGID_00000152982553141568583440000003209008817049602732_);}\n\t.st33{fill:url(#SVGID_00000005245307748529874340000013276195853773063811_);}\n\t.st34{fill:url(#SVGID_00000067923215154265676980000001309586115637386170_);}\n\t.st35{fill:url(#SVGID_00000067930397920020888300000009870340297449011098_);}\n\t.st36{fill:url(#SVGID_00000103969719035589227980000011494020746737567912_);}\n\t.st37{fill:url(#SVGID_00000053545623978475644160000011985610769044884918_);}\n\t.st38{fill:url(#SVGID_00000052088214179486840680000003303582242126690966_);}\n\t.st39{fill:url(#SVGID_00000153695559422635603050000001466167561261752767_);}\n\t.st40{fill:url(#SVGID_00000092458467484216352640000012652130042360882063_);}\n\t.st41{fill:url(#SVGID_00000160180519163385046070000015175884505536027306_);}\n\t.st42{fill:url(#SVGID_00000172408898853230177010000011636888434477012117_);}\n\t.st43{fill:url(#SVGID_00000001651265525613780710000015550335958907651994_);}\n\t.st44{fill:url(#SVGID_00000042734562645433668900000016187881900220148624_);}\n\t.st45{fill:url(#SVGID_00000106849786810024066250000002696331048418110886_);}\n\t.st46{fill:url(#SVGID_00000011730545923561970130000000894781972036838801_);}\n\t.st47{fill:url(#SVGID_00000068674527202965608800000011117679222901210549_);}\n\t.st48{fill:url(#SVGID_00000102540880107203711540000012989029622547813018_);}\n\t.st49{fill:url(#SVGID_00000122686243228093759660000001066887755464353950_);}\n\t.st50{fill:url(#SVGID_00000017499134727230633680000017862415708038670771_);}\n\t.st51{fill:url(#SVGID_00000132781476561325194940000007039935799764150148_);}\n\t.st52{fill:url(#SVGID_00000046322186248499515250000004986894647817759887_);}\n\t.st53{fill:url(#SVGID_00000159433257686118753610000004957401727480993450_);}\n\t.st54{fill:url(#SVGID_00000091013156205659695710000003277351146010911393_);}\n\t.st55{fill:url(#SVGID_00000036938393508100120730000006129231429114409614_);}\n\t.st56{fill:url(#SVGID_00000039092763795457823580000014585237835478588592_);}\n\t.st57{fill:url(#SVGID_00000057110662247824958100000000820411762637951154_);}\n\t.st58{fill:url(#SVGID_00000168820307389447500600000014442340442254987915_);}\n\t.st59{fill:url(#SVGID_00000126300921679507933120000005466754567010449577_);}\n\t.st60{fill:url(#SVGID_00000168796389074203031250000011738890922819183783_);}\n\t.st61{fill:url(#SVGID_00000008834906160380464980000007029057955692004523_);}\n\t.st62{fill:url(#SVGID_00000044170850935383717050000016081350949273268101_);}\n\t.st63{fill:url(#SVGID_00000011747457386271394560000001209397374551442848_);}\n\t.st64{fill:url(#SVGID_00000148647319686407866370000008107133174504336550_);}\n\t.st65{fill:url(#SVGID_00000156585443204768997360000015275107115896959677_);}\n\t.st66{fill:url(#SVGID_00000183229386885082554020000006835278912804773773_);}\n\t.st67{fill:url(#SVGID_00000049916963119569295400000008013297841997407661_);}\n\t.st68{fill:url(#SVGID_00000178896595342646042550000001854080010850032006_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -114.3934,
    y1: 98.1885,
    x2: -103.2265,
    y2: 98.1885,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-110.1-51.4c-1.3,0.5-2.6,1-3.9,1.4c-0.4,0.1-0.5-0.1-0.4-0.4c0.3-1,0.4-2,1.5-2.4c0.2-0.1,0.3-0.2,0.5-0.3 c0.4-0.2,0.5-0.5,0.5-0.9c0-0.8,0.7-1.2,1.4-0.8c0.3,0.2,0.4,0.1,0.6,0c0.5-0.3,0.8-0.6,0.8-1.3c0-0.6,0.8-0.9,1.4-0.6 c0.5,0.2,1.1-0.1,1.1-0.7c-0.1-1.4,0.2-2.8,0.7-4.2c0.1-0.3,0.3-0.6,0.5-0.8c0.3-0.3,0.7-0.3,0.9,0c0.2,0.2,0.3,0.4,0.4,0.6 c0.5,1.2,0.8,2.4,0.8,3.6c-0.3,0.1-0.2,0.3-0.2,0.5c0,1.6,0,3.1,0,4.7c0,0.8,0,1.6,0,2.4c0,0.2,0,0.4-0.2,0.5 c-0.3-0.2-0.2-0.4-0.2-0.7c0-2.6,0-5.2,0-7.8c0-1-0.2-2-0.7-3c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.3-0.4-0.3-0.6,0 c-0.3,0.5-0.4,1-0.6,1.6c-0.3,1-0.3,2-0.2,3c0,0.2,0,0.5-0.1,0.7c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.8,0,1.5,0,2.3c0,0.8-0.3,1-1.1,0.7 c0-0.3,0.2-0.2,0.3-0.2c0.4,0,0.5-0.2,0.5-0.5c0-0.9,0-1.8,0-2.8c-0.9,0.6-1.7,1.1-2.6,1.7c-1.2,0.8-2.4,1.6-3.6,2.3 c-0.5,0.3-0.6,0.8-0.7,1.3c0.3-0.6,0.8-0.8,1.3-1.1c1-0.4,2-0.8,2.9-1.2c0.2-0.1,0.3-0.2,0.5-0.1c0.1,0.1,0.2,0.2,0.3,0.3 c-0.1,0.2-0.3,0.3-0.5,0.3c-1.2,0.5-2.3,1-3.5,1.4c0.5-0.2,1.1-0.3,1.6-0.5c0.2-0.1,0.3-0.1,0.5-0.1 C-110.3-51.6-110.2-51.6-110.1-51.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002364283865620245550000012043753214096332982_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.0071,
    y1: 103.2507,
    x2: -118.7512,
    y2: 103.2507,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002364283865620245550000012043753214096332982_)"
    },
    d: "M-126.9-53.3c-0.1-0.2-0.1-0.4-0.1-0.5 c0-2.8,0-5.6,0-8.4c0-1.6,1-2.9,2.5-3.3c0.3-0.1,0.4-0.2,0.4-0.5c0-0.4,0-0.8,0-1.2c0-0.2,0-0.4-0.3-0.7c-0.3-0.3-0.2-0.8-0.1-1.2 c0.1-0.3,0.4-0.3,0.7-0.3c1.5,0,3,0,4.5,0c0.2,0,0.4-0.1,0.6,0.2c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.2-0.1,0.4-0.4,0.2 c-0.1-0.2-0.3-0.3-0.5-0.3c-1.4-0.1-2.8-0.2-4.1,0c-0.1,0.1-0.2,0.2-0.1,0.3c0.1,0.1,0.2,0,0.3-0.1c0.1-0.1,0.2-0.3,0.4-0.3 c0.9-0.1,1.9,0,2.9,0c0.4,0,0.8,0.4,1.2,0.5c0.1,0.1,0.1,0.2,0,0.2c-0.3,0-0.3,0.3-0.5,0.4c-0.1,0-0.2,0-0.3-0.1 c-0.3-0.4-0.7-0.4-1.1-0.4c-0.5,0-1,0-1.4,0c-0.5,0-1,0.5-1,1c0,0.3,0,0.6,0,0.9c0,0.4,0.1,0.5,0.5,0.5c0.8,0,1.7,0,2.5,0 c0.2,0,0.4,0,0.6,0.1c0.1,0.3-0.2,0.3-0.3,0.3c-0.5,0-1,0-1.5,0c0,0.1,0.2,0.2,0.1,0.3c-0.3,0.1-0.5,0.1-0.8,0c0,0-0.1,0-0.1-0.1 c-0.1-0.1,0-0.3-0.2-0.3c-0.2,0,0,0.3-0.1,0.3c-0.5,0.1-0.9,0.1-1.4,0.2c-0.3,0.1-0.7,0.2-1,0.4c-0.3,0.2-0.3,0.4-0.1,0.7 c0.4,0.5,0.7,1.1,0.6,1.8c0,0.2,0,0.4-0.1,0.5c-0.2,0.2-0.2,0.5-0.2,0.8c0,2.1,0,4.3,0,6.4c0,0.2,0,0.3,0,0.5 c0,0.2,0.1,0.5-0.2,0.7c-0.2-0.2-0.1-0.5-0.1-0.8c0-2.6,0-5.2,0-7.8c0-0.7-0.2-1.3-0.7-1.8c0,0.1,0,0.1,0,0.2 c-0.3,0.7-0.2,1.5-0.2,2.3c0,2.3,0,4.6,0,6.8c0,0.3,0.1,0.5-0.1,0.8c-0.3-0.1-0.2-0.4-0.2-0.6c0-1.8-0.1-3.6,0-5.4 c0-0.1,0-0.2,0-0.2c-0.1,2,0,4-0.1,6.1C-126.8-53.6-126.8-53.4-126.9-53.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062185918159726151640000011671363252544199808_",
    gradientUnits: "userSpaceOnUse",
    x1: -123.6423,
    y1: 101.2158,
    x2: -113.8314,
    y2: 101.2158,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062185918159726151640000011671363252544199808_)"
    },
    d: "M-116-65.1c1.4,1.1,1.7,3.1,0.8,4.6 c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.2,0.1,0.3,0.2,0.3c0.8-0.5,1,0.3,1.4,0.7c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1-0.3-0.2-0.5,0c-0.2,0.2-0.2,0.3,0,0.5c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4-0.3-0.8-0.7-0.4-1.3 c0,0,0-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2,0c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.8,0,1.5,0,2.3c-0.1,0-0.1-0.1-0.2-0.1c0,1,0,2,0,3 c0,0.2,0.1,0.5-0.3,0.5c-0.1-0.2-0.1-0.5-0.1-0.7c0-1.4,0-2.8,0-4.2c0-0.2,0.1-0.4-0.2-0.5c-0.3-0.1-0.7,0.2-0.7,0.5 c0,0.1,0,0.3,0,0.4c0,1.3,0,2.6,0,3.9c0,0.2,0,0.4-0.1,0.6c-0.3,0.2-0.3-0.1-0.3-0.2c0-0.5,0-0.9,0-1.3c-0.1,0.1-0.1,0.3-0.3,0.3 c-0.7-0.2-1.4,0-2.1-0.1c-0.4-0.1-0.8-0.1-1.2,0c-0.3,0-0.6,0-0.9,0c-0.2-0.1-0.5-0.1-0.8-0.1c-0.2,0-0.3,0-0.3-0.2 c0-0.2,0.2-0.2,0.3-0.2c0.2,0,0.3-0.1,0.4-0.1c1.2-0.1,2.5,0,3.8,0c0.7,0,0.7,0,0.7-0.7c0-0.7,0-1.3,0-2c0-0.3-0.1-0.5-0.4-0.5 c-0.6-0.1-1.2-0.4-1.7-0.7c-0.2-0.2-0.4-0.4-0.5-0.7c0-0.2,0.2-0.3,0.4-0.3c0.3,0.1,0.4,0.3,0.6,0.5c1.3,0.9,2.9,0.8,4-0.3 c1-1.1,1.1-2.8,0.1-4c-0.1-0.2-0.3-0.3-0.3-0.5C-116.3-65-116.3-65.2-116-65.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061471498295113976600000013844251397415030414_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.1886,
    y1: 106.6085,
    x2: -116.0261,
    y2: 106.6085,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061471498295113976600000013844251397415030414_)"
    },
    d: "M-120.8-60.3c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.6-0.2-0.6-0.8-0.8-1.3c-0.2-0.7-0.2-0.7-1-0.7c-0.3,0-0.6,0-0.9,0c-0.2,0-0.4-0.1-0.4-0.4c0-0.3,0.2-0.3,0.4-0.3 c0.4,0,0.9,0,1.3,0c0.2,0,0.4,0,0.4-0.3c0.2-0.7,0.5-1.3,1-1.8c-0.2-0.1-0.5,0-0.6-0.2c-0.1-0.2-0.4-0.1-0.5-0.4c0.6,0,1.2,0,1.8,0 c0.2,0,0.4,0.1,0.5-0.1c0.2-0.4,0.1-0.9,0.1-1.3c0-0.2-0.1-0.5,0.1-0.7c-0.2-0.2-0.2-0.4,0.2-0.4c0.1,0,0.2,0,0.3-0.1l0,0l0,0 c0.2-0.1,0.2-0.2,0.2-0.4c-0.1-0.2,0-0.3,0.2-0.4c0,0,0,0,0,0.1c0.1,0.4,0.1,0.8,0,1.1c-0.5,0.2-0.3,0.7-0.3,1.1 c0,0.9,0,0.9,0.8,0.9c0.8,0,1.6,0.3,2.2,0.8c-0.2,0-0.2,0.2-0.2,0.4c-0.2,0.1-0.3-0.1-0.5-0.2c-1.6-0.9-3.5-0.4-4.3,1.2 c-0.4,0.9-0.4,1.8,0,2.7C-120.9-60.8-120.7-60.6-120.8-60.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011032797100979361890000001614268570565928108_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.8776,
    y1: 86.3235,
    x2: -115.3776,
    y2: 86.3235,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011032797100979361890000001614268570565928108_)"
    },
    d: "M-129.9-40c0-2.7,0-5.3,0-8 c0-0.5,0.2-0.6,0.6-0.6c4.5,0,9,0,13.5,0c0.1,0,0.3,0,0.4,0.1c-0.2,0.2-0.5,0.2-0.8,0.2c-2.3,0-4.6,0-6.9,0c-0.2,0-0.4,0-0.6,0 c0.2,0.1,0.3,0,0.5,0c2.3,0,4.7,0,7,0c0.3,0,0.7-0.1,0.8,0.4c0,2.3,0,4.6,0,6.9c0,0.2,0.1,0.5-0.2,0.5c-0.2-0.2-0.1-0.4-0.1-0.7 c0-2.1,0-4.1,0-6.2c0-0.6,0-0.6-0.7-0.6c-4,0-8,0-12.1,0c-0.7,0-0.7,0-0.7,0.7c0,1,0,1.9,0,2.9c0,0.2,0,0.4-0.1,0.6 c-0.2,0.1-0.2,0-0.2-0.1c-0.1-0.2-0.1-0.4-0.1-0.6c0,1.3,0,2.6,0,3.8C-129.6-40.4-129.6-40.1-129.9-40z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131341816914516257820000009109687969066398638_",
    gradientUnits: "userSpaceOnUse",
    x1: -100.641,
    y1: 94.4206,
    x2: -95.3594,
    y2: 94.4206,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131341816914516257820000009109687969066398638_)"
    },
    d: "M-99.7-54.6c0.3,0,0.6-0.3,0.9-0.3 c0.7,0,0.9,0.2,0.9,0.9c0,0.4,0.1,0.7,0.5,0.9c0.1,0,0.1,0.1,0.2,0.1c1.4,0.9,1.4,0.9,1.8,2.6c0.1,0.4,0,0.6-0.4,0.4 c-1.6-0.6-3.2-1.1-4.8-1.7c-0.2-0.2,0-0.3,0.1-0.3c1.1,0.2,2.2,0.7,3.2,1c-0.7-0.3-1.5-0.6-2.2-0.9c-0.2-0.1-0.4-0.1-0.6-0.3 c-0.1-0.2-0.2-0.4,0.1-0.5c1,0.3,2,0.7,3,1.1c0.4,0.2,0.5,0.6,0.8,0.9c-0.1-0.7-0.3-1.2-1-1.5c-0.9-0.5-1.6-1.1-2.5-1.6 c-0.2-0.1-0.3-0.2-0.4-0.4C-100-54.4-99.9-54.5-99.7-54.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049903224205348945160000013938706080231031941_",
    gradientUnits: "userSpaceOnUse",
    x1: -119.9624,
    y1: 85.6826,
    x2: -114.8482,
    y2: 85.6826,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049903224205348945160000013938706080231031941_)"
    },
    d: "M-115.7-40.5c0.2-0.1,0.1-0.3,0.1-0.5 c0-2.3,0-4.6,0-6.9c0.3-0.1,0.3,0.1,0.3,0.3c0,0.6,0,1.3,0,1.9c0,0.1,0,0.3,0,0.5c0,1.4,0,2.8,0,4.2c0,0.6,0.1,1,0.4,1.5 c-0.2,0.1-0.3,0.2-0.5,0.1c-0.4-0.4-0.9-0.6-1.5-0.6c-0.8,0-1.6,0-2.4,0c-0.2,0-0.4,0-0.6-0.1c-0.1-0.4,0.2-0.5,0.5-0.5 c0.4,0,0.8,0.1,1.2-0.1c0.2-0.2,0.1-0.4,0-0.6c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2,0.1-0.3,0.3-0.3c0.4,0.2,0.6,0.5,0.7,0.9 c0.1,0.4,0.3,0.4,0.6,0.4c0.3,0,0.3-0.2,0.3-0.5c0-0.4,0-0.8,0-1.2c0-0.3-0.1-0.6-0.3-0.9c0-0.2-0.4-0.4,0-0.6c0.7,0.1,1,0.5,1,1.2 c0,0.6,0,1.2,0,1.8C-115.8-40.8-115.8-40.6-115.7-40.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047780175794883220140000015193915949866689466_",
    gradientUnits: "userSpaceOnUse",
    x1: -121.8751,
    y1: 78.9708,
    x2: -114.1946,
    y2: 78.9708,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047780175794883220140000015193915949866689466_)"
    },
    d: "M-115.2-39.4c0.1-0.2,0.2-0.2,0.4-0.1 c0.1,0.3,0.2,0.5,0.2,0.8c0.1,0.3,0,0.7,0.3,0.9c0.1,0.1,0.1,0.3,0.1,0.4c0,0.4,0,0.8,0,1.2c0,0.4,0,0.7-0.5,0.8 c-0.2,0.1-0.2,0.2-0.2,0.4c0,0.4-0.2,0.6-0.6,0.6c-0.4,0-0.7,0-1.1,0c-0.9,0-0.9-0.1-0.9-1c-0.2-0.1-0.3,0-0.5,0 c-1.3,0-2.6,0-3.8,0c0-0.2,0.1-0.2,0.2-0.2c0.6,0,1.1-0.2,1.7-0.2c1.3,0,2.7,0,4,0c0.2,0,0.4,0,0.6,0c0.6-0.1,0.6-0.1,0.6-0.7 c0-1.1,0.1-1-1-1.1c-0.3,0-0.6,0.1-0.9-0.1c-0.2-0.2,0-0.3,0.1-0.5c0.3-0.1,0.5-0.1,0.8-0.1c0.6,0,0.7,0,0.6-0.7 C-115.3-39-115.3-39.2-115.2-39.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021105763682537956050000000025963837742653330_",
    gradientUnits: "userSpaceOnUse",
    x1: -130.8221,
    y1: 78.2901,
    x2: -124.5122,
    y2: 78.2901,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021105763682537956050000000025963837742653330_)"
    },
    d: "M-129-34.3c-0.1,0-0.3,0-0.5,0 c-0.8,0-0.8,0-0.9-0.8c0-0.1,0-0.1,0-0.2c-0.6-0.7-0.2-1.5-0.3-2.2c0-0.2,0.1-0.5,0.4-0.5c0.1-0.1,0.3-0.2,0.5-0.2 c1.4,0.1,2.8,0,4.3,0c0.2,0,0.5,0,0.7,0.1c0.2,0.2,0.1,0.3-0.1,0.5c-0.2,0.1-0.4,0.1-0.7,0.1c-1.3,0-2.6,0-3.9,0 c-0.6,0-0.6,0.1-0.6,0.6c0,1.1-0.1,1,1,1c1.3,0,2.7,0,4,0c0.2,0,0.5,0,0.7,0.1c0.1,0.4-0.3,0.3-0.4,0.3c-0.8,0-1.6,0-2.4,0 c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0.1-0.4,0.2c-0.2,0.2-0.5,0.1-0.8,0.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.3,0.1 c0,0.2,0.2,0.1,0.3,0.1c0.3,0,0.6,0,0.8,0.1c0.2,0.2,0,0.2-0.1,0.3C-128.8-34.4-128.9-34.4-129-34.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091703079059264434290000006479674424581097103_",
    gradientUnits: "userSpaceOnUse",
    x1: -103.6098,
    y1: 97.5032,
    x2: -99.6906,
    y2: 97.5032,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091703079059264434290000006479674424581097103_)"
    },
    d: "M-99.7-54.6c0,0.1-0.2,0.2-0.2,0.4 c-0.2,0.1-0.3-0.1-0.5-0.2c-0.7-0.5-1.5-0.9-2.2-1.4c-0.1-0.1-0.3-0.3-0.4-0.2c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.7,0,1.5,0,2.2 c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.2,0.1-0.4,0c0-1.7,0-3.4,0-5.1c0-0.1-0.1-0.3,0.1-0.4c0.1,0,0.2,0.2,0.3,0.2c0,0.2,0,0.3,0,0.5 c-0.1,0.5,0.1,0.8,0.5,1c0.2,0.1,0.3,0.2,0.5,0c0.4-0.2,0.8-0.2,1.2,0c0.2,0.1,0.3,0.2,0.3,0.4C-100.8-55.4-100.4-55-99.7-54.6 C-99.7-54.7-99.7-54.6-99.7-54.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146485996509280521920000006430834515273546685_",
    gradientUnits: "userSpaceOnUse",
    x1: -110.4663,
    y1: 94.8526,
    x2: -105.953,
    y2: 94.8526,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146485996509280521920000006430834515273546685_)"
    },
    d: "M-108.5-52.8c-0.2,0-0.3-0.1-0.3-0.3 c0.2-0.3,0.6-0.4,0.9-0.3c0.3,0.1,0.5,0.3,0.4,0.6c0.3,0.2,0.6,0.1,0.8,0.1c0.2,0,0.2-0.2,0.2-0.4c0-1,0-2,0-2.9 c0-0.4,0.1-0.4,0.4-0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,1.8,0,3.6,0,5.4c0,0.1,0,0.1,0,0.2c-0.2,0.2-0.2,0.5-0.4,0.8 c-0.2-0.8-0.2-1.6-0.1-2.4c0-0.4-0.1-0.5-0.5-0.5c-0.6,0-1.1,0.2-1.6,0.4c-0.5,0.2-1,0.3-1.4,0.5c-0.2,0-0.3,0-0.4-0.2 c0.1-0.2,0.2-0.2,0.4-0.3c0.5-0.2,1-0.4,1.5-0.6c0.1,0,0.3,0,0.3-0.2C-108.3-52.8-108.4-52.7-108.5-52.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019649141322734915050000010570784514532278944_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.0476,
    y1: 77.1123,
    x2: -115.3076,
    y2: 77.1123,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019649141322734915050000010570784514532278944_)"
    },
    d: "M-128.1-35.3c-0.3-0.4,0-0.4,0.2-0.4 c1,0,1.9,0,2.9,0c0.2,0,0.3,0,0.5-0.1c0.2-0.2,0.4-0.2,0.6-0.2c2.7,0,5.3,0,8,0c0.2,0,0.4,0,0.6,0.2c-0.2,0.1-0.3,0.1-0.5,0.1 c-1,0-2,0-3,0c-1,0-2,0-3.1,0.3c0.2,0,0.4,0,0.6,0c1.1,0,2.2,0,3.3,0c0.2,0,0.3-0.1,0.5,0.1c-2.3,0-4.5,0-6.8,0c-1,0-2,0-3.1,0 c-0.2,0-0.3,0-0.4,0.3c0,0.6-0.1,0.7-0.8,0.7c-0.2,0-0.4,0-0.6,0c0.1-0.2,0.4-0.1,0.5-0.4C-128.3-34.8-128.2-35-128.1-35.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015320657374300577670000011082818823194606979_",
    gradientUnits: "userSpaceOnUse",
    x1: -104.2076,
    y1: 92.6786,
    x2: -99.7694,
    y2: 92.6786,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015320657374300577670000011082818823194606979_)"
    },
    d: "M-103.6-52.8c0.1,0,0.2,0,0.3,0 c0.5,0,0.9,0,1.2-0.5c0.1-0.2,0.3-0.2,0.6-0.2c0.5,0.1,1.1,0.4,1.6,0.6c0.1,0,0.1,0.1,0.1,0.2c-0.3,0-0.2,0.2-0.1,0.4 c-0.2,0.2-0.4,0-0.6-0.1c-0.4-0.1-0.7-0.3-1.2-0.4c0.2,0.3,0.5,0.3,0.8,0.4c0.2,0.1,0.5,0.1,0.5,0.4c-0.1,0-0.2,0.1-0.1,0.3 c-0.3-0.1-0.6-0.2-1-0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.9-0.2-1-0.1-1,0.8c0,1.1,0,2.3-0.5,3.3c-0.2-0.2-0.3,0.2-0.5,0.2 c0,0-0.1-0.1-0.1-0.1c0.1-0.6,0.2-1.3,0.5-1.8c0.2-0.4,0.1-0.8,0.1-1.2C-103.6-51.6-103.6-52.2-103.6-52.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092444543762328128050000017285973747722332835_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.1027,
    y1: 88.8835,
    x2: -115.1953,
    y2: 88.8835,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092444543762328128050000017285973747722332835_)"
    },
    d: "M-115.2-45.2c-0.2-0.7,0-1.5-0.1-2.2 c0-0.2,0.1-0.5-0.3-0.5c0-0.3-0.2-0.3-0.5-0.3c-2.5,0-4.9,0-7.4,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2-0.1-0.2-0.2 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.4,0c2.7,0,5.4,0,8.2,0c0.2,0,0.2,0.2,0.2,0.3C-115.2-47.2-115.2-46.2-115.2-45.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166666148644510515710000010545216695215946659_",
    gradientUnits: "userSpaceOnUse",
    x1: -115.3012,
    y1: 99.6428,
    x2: -112.006,
    y2: 99.6428,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166666148644510515710000010545216695215946659_)"
    },
    d: "M-114.3-59.1c0.2,0,0.3-0.1,0.5-0.1 c0.5,0.5,1.1,1.1,1.6,1.6c0.3,0.4,0.3,0.6,0,1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.3-0.6,0.3-1,0c-0.6-0.6-1.2-1.2-1.7-1.8 c0-0.2,0.1-0.3,0.3-0.3c0.5,0.1,0.7,0.6,1.1,0.9c0.2,0.2,0.4,0.5,0.7,0.7c0.2,0.2,0.3,0.1,0.5,0c0.2-0.2,0.2-0.3,0-0.5 c-0.3-0.3-0.7-0.7-1-1C-114-58.6-114.2-58.8-114.3-59.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008107350607438441030000003255716759508234925_",
    gradientUnits: "userSpaceOnUse",
    x1: -130.3634,
    y1: 83.5235,
    x2: -128.975,
    y2: 83.5235,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008107350607438441030000003255716759508234925_)"
    },
    d: "M-129.9-38.2c-0.1,0-0.3,0.1-0.4,0.1 c0-0.7,0-1.4,0.5-1.9c0.2-0.1,0.1-0.3,0.1-0.5c0-1.3,0-2.7,0-4c0-0.1,0-0.3,0.1-0.5c0.2,0.2,0.2,0.5,0.2,0.8c0,0.2-0.1,0.4,0.1,0.6 c0.2,0.2,0.1,0.4,0.1,0.6c0,0.6,0,1.3,0,1.9c0,0.2,0,0.4,0.2,0.5c0.2,0.2,0.1,0.4,0.1,0.5C-129.7-39.6-129.7-38.8-129.9-38.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021826157964974410920000005133667638546579874_",
    gradientUnits: "userSpaceOnUse",
    x1: -126.9161,
    y1: 98.5685,
    x2: -126.4955,
    y2: 98.5685,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021826157964974410920000005133667638546579874_)"
    },
    d: "M-126.5-53.4c-0.2,0-0.2,0.2-0.3,0.3 c0-0.1-0.1-0.1-0.1-0.2c0.1-2.3-0.1-4.5,0.1-6.8c0.1,0,0.1,0,0.2,0c0,0.4,0,0.7,0,1.1c0,1.6,0,3.3,0,4.9c0,0.2-0.1,0.3,0.1,0.5 C-126.5-53.5-126.5-53.5-126.5-53.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078012790491610799550000006524327342369914815_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.6646,
    y1: 100.3343,
    x2: -130.3404,
    y2: 100.3343,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078012790491610799550000006524327342369914815_)"
    },
    d: "M-130.3-59.3c0,0.1-0.1,0.1-0.1,0.2 c-0.2,0.5-0.5,1.1-0.7,1.6c-0.1,0.2-0.1,0.3-0.3,0.2c-0.2-0.1-0.2-0.3-0.1-0.4c0.3-0.6,0.5-1.2,0.8-1.8c0.1-0.1,0.2-0.2,0.3-0.2 C-130.4-59.5-130.3-59.4-130.3-59.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150076251646378064040000010731106576554746532_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.0068,
    y1: 87.817,
    x2: -130.8079,
    y2: 87.817,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150076251646378064040000010731106576554746532_)"
    },
    d: "M-130.8-44.9c0,0.2-0.1,0.3-0.2,0.3 c-0.1,0-0.2,0-0.2-0.1c-0.3-0.7-0.6-1.4-0.8-2.1c0-0.1,0-0.2,0.2-0.3c0.1,0,0.2,0,0.2,0.1C-131.3-46.3-131.1-45.5-130.8-44.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082358182769244919000000000577126597307752088_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.6482,
    y1: 96.2456,
    x2: -131.841,
    y2: 96.2456,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082358182769244919000000000577126597307752088_)"
    },
    d: "M-132.6-53.3c0.1-0.6,0.2-1.3,0.3-1.9 c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.2,0.2,0.2,0.4c-0.1,0.6-0.2,1.2-0.3,1.9c0,0.2-0.1,0.3-0.2,0.3C-132.6-53-132.7-53.1-132.6-53.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082346021114703933650000006826301975476667814_",
    gradientUnits: "userSpaceOnUse",
    x1: -113.0136,
    y1: 109.4436,
    x2: -110.5052,
    y2: 109.4436,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082346021114703933650000006826301975476667814_)"
    },
    d: "M-110.7-66.9c-0.8-0.2-1.4-0.4-2.1-0.5 c-0.1,0-0.2-0.1-0.2-0.3c0-0.2,0.2-0.2,0.3-0.2c0.7,0.2,1.3,0.4,2,0.6c0.1,0,0.2,0.2,0.2,0.3C-110.6-66.9-110.7-66.9-110.7-66.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082335354046196449750000006964134502612944537_",
    gradientUnits: "userSpaceOnUse",
    x1: -117.2823,
    y1: 110.0085,
    x2: -114.7318,
    y2: 110.0085,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082335354046196449750000006964134502612944537_)"
    },
    d: "M-116-67.8c-0.3,0-0.6,0-0.9,0 c-0.2,0-0.3,0-0.3-0.2c0-0.2,0.1-0.2,0.3-0.2c0.7,0,1.3,0,2,0c0.2,0,0.3,0.1,0.3,0.2c0,0.2-0.1,0.2-0.3,0.2 C-115.4-67.8-115.7-67.8-116-67.8L-116-67.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166672272065628053360000017637397580327023243_",
    gradientUnits: "userSpaceOnUse",
    x1: -108.9709,
    y1: 107.7985,
    x2: -106.6759,
    y2: 107.7985,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166672272065628053360000017637397580327023243_)"
    },
    d: "M-108.7-66.6c0.1,0.1,0.3,0.1,0.5,0.2 c0.4,0.3,0.9,0.5,1.3,0.8c0.1,0.1,0.3,0.2,0.1,0.4c-0.1,0.2-0.2,0.1-0.4,0c-0.6-0.3-1.1-0.7-1.7-1c-0.1-0.1-0.2-0.2-0.2-0.3 C-108.9-66.5-108.8-66.6-108.7-66.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068654003198233187130000014888708443254339774_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.6811,
    y1: 91.9784,
    x2: -132.0439,
    y2: 91.9784,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068654003198233187130000014888708443254339774_)"
    },
    d: "M-132.1-49c0.1,0.2,0,0.3-0.2,0.3 c-0.2,0-0.2-0.1-0.3-0.2c-0.1-0.7-0.2-1.4-0.2-2.1c0-0.1,0-0.2,0.2-0.2c0.2,0,0.2,0.1,0.2,0.2C-132.2-50.3-132.1-49.7-132.1-49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160875958523470826690000016236289149293590412_",
    gradientUnits: "userSpaceOnUse",
    x1: -105.8242,
    y1: 81.5984,
    x2: -103.8284,
    y2: 81.5984,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160875958523470826690000016236289149293590412_)"
    },
    d: "M-103.8-40.3c0,0.1-0.1,0.2-0.2,0.3 c-0.4,0.4-0.9,0.8-1.3,1.3c-0.1,0.1-0.3,0.2-0.4,0c-0.1-0.2,0-0.3,0.1-0.4c0.4-0.4,0.9-0.8,1.3-1.3c0.1-0.1,0.2-0.2,0.3-0.1 C-103.9-40.5-103.9-40.4-103.8-40.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142875265394454526980000014501750392852697510_",
    gradientUnits: "userSpaceOnUse",
    x1: -102.888,
    y1: 84.9046,
    x2: -101.3335,
    y2: 84.9046,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142875265394454526980000014501750392852697510_)"
    },
    d: "M-102.7-41.8c-0.2,0-0.3-0.2-0.2-0.3 c0.4-0.6,0.7-1.2,1.1-1.8c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.1,0.2c-0.3,0.7-0.7,1.3-1.2,1.9 C-102.6-41.8-102.6-41.8-102.7-41.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181087111086416810970000001432593974180005039_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.6746,
    y1: 103.8924,
    x2: -127.9821,
    y2: 103.8924,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181087111086416810970000001432593974180005039_)"
    },
    d: "M-129.4-60.9c-0.2-0.1-0.3-0.2-0.2-0.4 c0.4-0.5,0.8-1,1.2-1.5c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0.1,0.1,0.2,0.1,0.3c-0.4,0.5-0.8,1-1.2,1.5 C-129.3-60.9-129.4-60.9-129.4-60.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112595827311765043430000012910868328610825125_",
    gradientUnits: "userSpaceOnUse",
    x1: -108.139,
    y1: 79.4615,
    x2: -107.1294,
    y2: 79.4615,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112595827311765043430000012910868328610825125_)"
    },
    d: "M-107.1-37.6c0,0.2-0.7,0.6-0.9,0.5 c-0.1-0.1-0.2-0.2-0.1-0.3c0.2-0.2,0.5-0.4,0.8-0.5C-107.2-37.8-107.1-37.8-107.1-37.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057143101763655942660000018086018465580258710_",
    gradientUnits: "userSpaceOnUse",
    x1: -118.7286,
    y1: 110.4335,
    x2: -118.6313,
    y2: 110.4335,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057143101763655942660000018086018465580258710_)"
    },
    d: "M-118.7-67.9c0-0.4,0-0.8,0-1.1 C-118.6-68.6-118.6-68.2-118.7-67.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158717894904200148130000011759271338175030199_",
    gradientUnits: "userSpaceOnUse",
    x1: -125.2338,
    y1: 99.7485,
    x2: -122.5358,
    y2: 99.7485,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158717894904200148130000011759271338175030199_)"
    },
    d: "M-124.9-61.6c0,1.9,0,3.9,0,5.8 c0,0.4,0.1,0.5,0.5,0.5c0.5,0,1,0,1.4,0c-0.2,0.2-0.4,0.2-0.7,0.2c0.4,0.3,0.8,0,1.1,0.2c-0.3,0.2-0.6,0.1-0.9,0.1 c-0.1,0-0.2,0-0.4,0c-0.8,0-0.8,0-1,0.7c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.2,0-0.3,0c0-2.5,0-4.9,0-7.4 C-125.2-61.5-125-61.6-124.9-61.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070105083845176941220000016008216563773966007_",
    gradientUnits: "userSpaceOnUse",
    x1: -123.0525,
    y1: 107.3694,
    x2: -122.3849,
    y2: 107.3694,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070105083845176941220000016008216563773966007_)"
    },
    d: "M-122.5-65.2c-0.1,0-0.2,0-0.3,0 c-0.1-0.1-0.1-0.2-0.2-0.3c0.2-0.1,0.5-0.1,0.6,0C-122.3-65.4-122.5-65.3-122.5-65.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170983423676002467590000006487001080602236046_",
    gradientUnits: "userSpaceOnUse",
    x1: -121.6076,
    y1: 96.9323,
    x2: -120.4954,
    y2: 96.9323,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170983423676002467590000006487001080602236046_)"
    },
    d: "M-120.5-54.9c-0.4,0-0.7,0-1.1,0 C-121.2-55-120.9-55-120.5-54.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098215091365550972310000017532754493040375692_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.2879,
    y1: 83.2318,
    x2: -117.9876,
    y2: 83.2318,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098215091365550972310000017532754493040375692_)"
    },
    d: "M-119.9-40.2c-1.4,0-2.8,0-4.3,0 c-0.2-0.3,0-0.4,0.2-0.5c0.2,0,0.4,0,0.6,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0-0.3,0.1-0.4c0.1-0.2,0.2-0.3,0.4-0.2 c0.1,0.3-0.1,0.5,0.1,0.8c0.5,0,0.5,0,0.6-0.7c0.1-0.5,0.5-0.9,1-0.9c0.8,0,1.7,0,2.5,0c0.2,0,0.3,0.1,0.4,0.2 c-0.1,0.1-0.2,0.2-0.2,0.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.6,0-1.2,0-1.8,0c-0.2,0-0.4,0-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.5 c0.1,0.2,0.2,0.2,0.4,0.2c0.8,0,1.7,0,2.5,0c0.2,0,0.4,0,0.6,0.1c-0.5,0.2-0.9,0.1-1.4,0.1C-119.7-40.6-119.9-40.5-119.9-40.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018230655752574520240000014253413775933377964_",
    gradientUnits: "userSpaceOnUse",
    x1: -122.6641,
    y1: 86.5623,
    x2: -116.7648,
    y2: 86.5623,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018230655752574520240000014253413775933377964_)"
    },
    d: "M-116.8-43.5c-0.9-0.4-1.8-0.7-2.7-1.1 c-0.8-0.3-1.5-0.5-2.3-0.6c-0.3-0.1-0.7,0-0.9-0.3c0.3-0.1,0.6-0.1,0.9,0c0.9,0,1.7,0.2,2.5,0.6c0.8,0.3,1.6,0.7,2.4,1.1 C-117-43.8-116.7-43.6-116.8-43.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138560744394020558950000016522180134414602677_",
    gradientUnits: "userSpaceOnUse",
    x1: -113.6749,
    y1: 79.0899,
    x2: -109.7947,
    y2: 79.0899,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138560744394020558950000016522180134414602677_)"
    },
    d: "M-109.8-35.9c0-0.9,0-1.8,0-2.7 c0-1.4,0-1.4-1.4-1.3c-0.3,0-0.2,0.2-0.2,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.3,0.1,0.3,0.3c0,0.9,0,1.8,0,2.7 c0,0.2-0.1,0.3-0.3,0.3c-0.8,0-1.6,0.1-2.4-0.1c-0.2-0.1-0.1-0.3-0.1-0.5c0-0.3,0-0.6,0-0.8c0-0.1-0.1-0.2-0.2-0.2 c-0.2,0-0.2,0.1-0.2,0.3c0,0.7,0,1.3,0,1.9c0.3,0.1,0.4,0.2,0.4,0.6c0,0.1,0,0.2,0,0.3c-0.1,0.4,0.1,0.5,0.5,0.5c0.7,0,1.3,0,2,0 c0.6,0,0.6,0,0.6-0.6c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0.2-0.2C-109.7-35.5-109.8-35.7-109.8-35.9z M-111-34.7c-0.5,0-1.1,0-1.6,0 c-0.3,0-0.3-0.2-0.3-0.4c0-0.2-0.1-0.4,0.3-0.4c0.3,0,0.6,0,0.8,0c0.2,0,0.4,0,0.6,0c0.4-0.1,0.5,0.1,0.5,0.5 C-110.7-34.7-110.7-34.6-111-34.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159439541439753866820000010888770904182013369_",
    gradientUnits: "userSpaceOnUse",
    x1: -114.0911,
    y1: 81.8328,
    x2: -111.1302,
    y2: 81.8328,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159439541439753866820000010888770904182013369_)"
    },
    d: "M-111.3-41.9c-0.4-0.1-0.3-0.3-0.3-0.6 c0-1.2-0.8-1.8-1.9-1.6c-0.3,0-0.7,0.6-0.6,0.7c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.2-0.3,0.3-0.5c0-0.4,0.2-0.3,0.5-0.2 c0.1,0.1,0.2,0.1,0.3,0.2c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.4-0.3,0.6c0.1,0.2,0.5,0.3,0.7,0.2c0.2,0,0.1-0.4,0.2-0.6 c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.2,0.2-0.1c0.3,0.2,0.2,0.5,0.2,0.7c0,0.2,0.1,0.4-0.2,0.4c-0.3,0-0.4,0.2-0.4,0.5 c0,0.2,0,0.4,0.1,0.6c0.1,0.9,0.1,0.9-0.8,0.9c-0.3,0-0.5,0.1-0.5,0.5c0,1.2,0,2.4,0,3.6c0,0.1,0,0.2,0.1,0.4c0-0.6,0-1.2,0-1.8 c0-0.1,0-0.3,0.1-0.3c0.2,0,0.1,0.2,0.2,0.3c0,0.5-0.1,1,0.1,1.4c0.2-0.2,0.2-0.4,0.2-0.6c0-0.7,0-1.5,0-2.2c0-0.7,0-0.7,0.7-0.7 c0.4,0,0.8,0.1,1.1-0.1c0-0.1,0-0.3,0.1-0.4c-0.1-0.5,0-1,0-1.5C-111.1-41.6-111.1-41.8-111.3-41.9z M-113.5-43.4 c-0.1,0-0.2,0-0.2-0.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2C-113.3-43.5-113.3-43.4-113.5-43.4z M-111.6-40.2 c0,0.1,0,0.2-0.2,0.2c-0.2,0-0.2-0.1-0.2-0.3c0-0.4,0-0.7-0.1-1c-0.1-0.4,0.1-0.4,0.3-0.4c0.2,0,0.3,0.1,0.3,0.3 C-111.6-40.9-111.6-40.6-111.6-40.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061455431232058449890000017963527665813249179_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.9521,
    y1: 79.8785,
    x2: -116.5976,
    y2: 79.8785,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061455431232058449890000017963527665813249179_)"
    },
    d: "M-116.8-37.7c-2.7,0-5.4,0-8.2,0 c0-0.1,0-0.3,0.1-0.4c2.8,0,5.5,0,8.3,0C-116.7-37.9-116.7-37.8-116.8-37.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124129347476045763750000004024483963406653349_",
    gradientUnits: "userSpaceOnUse",
    x1: -106.2927,
    y1: 88.2179,
    x2: -101.0714,
    y2: 88.2179,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124129347476045763750000004024483963406653349_)"
    },
    d: "M-101.4-46.4c-0.7-0.4-1.4-0.7-2-1.1 c-0.3-0.2-0.4-0.3-0.2-0.6c0-0.2-0.1-0.2-0.2-0.1c-0.1,0-0.2,0.2-0.3,0.3c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.6-0.2,1.3-0.3,1.9 c0,0.2,0,0.4-0.2,0.6c-0.3-0.3-0.1-0.7-0.3-0.9c-0.1-0.1-0.2-0.2-0.4-0.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3,0.1 c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1,0,0.2,0.1c0.3,0,0.3,0.2,0.4,0.4c0.1,0.4,0.2,0.7,0.7,0.7c0.5,0,0.6-0.3,0.7-0.7 c0-0.3,0.2-0.4,0.5-0.4c0.7,0,1.3,0,2,0c0.3,0,0.6-0.1,0.7-0.5C-101-46.1-101.2-46.2-101.4-46.4z M-101.6-45.8 c0,0.1-0.1,0.1-0.2,0.1c-0.3,0-0.7,0-1,0l0,0c-0.2,0-0.5,0-0.7,0c-0.5,0.1-0.5-0.2-0.5-0.6c0-0.2,0.1-0.4,0.1-0.7 c0-0.1,0.1-0.2,0.3-0.1c0.6,0.4,1.3,0.7,1.9,1C-101.6-46-101.5-46-101.6-45.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018937804691728437370000002247097635977344649_",
    gradientUnits: "userSpaceOnUse",
    x1: -108.6532,
    y1: 89.6733,
    x2: -105.1416,
    y2: 89.6733,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018937804691728437370000002247097635977344649_)"
    },
    d: "M-105.1-46.3c-0.1-1.3-0.6-2.5-0.9-3.8 c-0.4,0.1-0.2,0.4-0.3,0.7c0,0.5,0.2,0.9,0.3,1.3c0.1,0.3,0,0.4-0.2,0.6c-0.7,0.4-1.3,0.7-2,1.1c-0.2,0.1-0.4,0.3-0.3,0.6 c0.1,0.3,0.2,0.5,0.6,0.5c0.7,0,1.4,0,2.1,0c-0.1-0.1-0.2-0.2-0.3-0.3c0.2-0.2,0.5,0.1,0.6-0.2c-0.8,0.1-1.5,0-2.3,0 c-0.1,0-0.2,0-0.2-0.1c0-0.1,0.1-0.1,0.1-0.2c0.6-0.4,1.3-0.7,1.9-1c0.2-0.1,0.2,0,0.3,0.2c0,0.4,0.1,0.7,0.2,1 c0.1,0,0.3,0.1,0.4,0.1C-105.1-45.9-105.1-46.1-105.1-46.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062874002035910639780000013987977909758537652_",
    gradientUnits: "userSpaceOnUse",
    x1: -120.6121,
    y1: 96.4896,
    x2: -116.2171,
    y2: 96.4896,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062874002035910639780000013987977909758537652_)"
    },
    d: "M-116.2-56.8c-0.2-0.1-0.1-0.4-0.4-0.6 c0,1.2,0,2.4,0,3.5c0,0.2,0.1,0.4-0.1,0.5c-0.8,0.6-0.8,0.6-1.2,0.1c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.5,0-1,0-1.5 c-0.4,0.1-0.2,0.5-0.4,0.7c-0.2,0.3-0.1,0.7-0.1,1.1c0,0.7,0,0.7-0.6,0.8c-0.2,0-0.3,0.1-0.4,0.1c-0.2,0-0.5,0.1-0.7,0.1 c-0.1,0-0.3,0-0.3,0.2c0,0.2,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.4,0c0.3,0,0.6-0.1,0.9,0.1c-0.1,0.4,0.1,0.6,0.5,0.7 c0.5,0.1,0.8-0.1,0.8-0.5c0-0.2,0.2-0.2,0.3-0.3c0.7-0.2,1.2-0.6,1.2-1.3C-116.2-54.7-116.2-55.7-116.2-56.8z M-118.4-52 c-0.1,0-0.2,0-0.2-0.1c0-0.2,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.2C-118.2-52-118.3-52-118.4-52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016066989398108027850000007832738487973975725_",
    gradientUnits: "userSpaceOnUse",
    x1: -126.5402,
    y1: 95.0973,
    x2: -126.0464,
    y2: 95.0973,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016066989398108027850000007832738487973975725_)"
    },
    d: "M-126.5-53.4c0.2,0.2,0.3,0.4,0.5,0.5 C-126.5-52.7-126.6-53-126.5-53.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089560429620652707200000011370158259819278745_",
    gradientUnits: "userSpaceOnUse",
    x1: -126.8414,
    y1: 94.7241,
    x2: -119.0114,
    y2: 94.7241,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089560429620652707200000011370158259819278745_)"
    },
    d: "M-119.5-52.4c-0.3,0-0.7,0-1.1-0.1 c0.5-0.2,1-0.1,1.4-0.3c-0.2-0.2-0.4-0.2-0.7-0.2c-1.2,0-2.4,0-3.6,0c-0.3,0-0.7,0-1,0c-0.5,0-0.5,0-0.5-0.5c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.2,0.1,0.5-0.1,0.7c-0.2,0.1-0.4,0.4-0.8,0.3c-0.3,0.1-0.3-0.2-0.4-0.4c0,0-0.1-0.1-0.1-0.1 c-0.2,0-0.2,0.2-0.3,0.3c0.1,0.5,0.5,0.7,0.9,0.8c0.2,0.1,0.4,0.1,0.4,0.4c0,0.3,0.3,0.4,0.6,0.4c0.3,0,0.7,0,0.7-0.3 c0.1-0.5,0.4-0.4,0.7-0.4c0.6,0,1.1,0,1.7,0c0.9,0,1.8,0,2.8,0C-119.1-52.4-119.3-52.4-119.5-52.4z M-124.8-52 c-0.1,0-0.2,0-0.2-0.2c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1C-124.6-52-124.7-52-124.8-52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013194245828596786800000006645821176046126219_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.1211,
    y1: 83.1708,
    x2: -122.8164,
    y2: 83.1708,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013194245828596786800000006645821176046126219_)"
    },
    d: "M-122.8-41.4c-0.2,0-0.3,0.1-0.3,0.3 c0,0.2,0.1,0.3-0.1,0.5c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2-0.7-0.2-0.7-0.9-0.7c-0.7,0-1.5,0-2.2,0c-0.2,0-0.4,0-0.5,0.1 c-0.2,0.1-0.3,0.3-0.3,0.5c0.1,0.2,0.3,0.2,0.4,0.2c1,0,2,0,3,0c0.2,0,0.5,0,0.7,0.1c-0.2,0.2-0.4,0.1-0.7,0.1 c-0.3,0-0.4,0.1-0.4,0.4c-1.3,0-2.7,0-4.1,0c-0.3,0-0.5,0-0.8,0.1c-0.2-0.2,0-0.3,0-0.5v0c0,0,0-0.1,0.1-0.2c0-0.1-0.1-0.3,0.1-0.4 c0.2,0,0.2,0.2,0.3,0.3c0.1,0.1-0.1,0.3,0.2,0.2c0.2-0.1,0.5,0.1,0.5-0.3c0-0.6,0.2-1,0.8-1.2c0.1,0,0.3-0.1,0.4-0.1 c0.9,0,1.9,0,2.8,0C-123.3-42.2-123-42-122.8-41.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169546873362261375260000008982222367432630961_",
    gradientUnits: "userSpaceOnUse",
    x1: -105.6277,
    y1: 102.2407,
    x2: -104.1097,
    y2: 102.2407,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169546873362261375260000008982222367432630961_)"
    },
    d: "M-104.9-60.6c0.1,0,0.2,0,0.3,0.1 c0.2,0.1,0.5,0.2,0.4,0.4c-0.1,0.3-0.3,0.1-0.5,0c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.2,0.1-0.3,0.2-0.4 C-105.2-60.5-105.1-60.6-104.9-60.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129191565339466920280000006273150368365830278_",
    gradientUnits: "userSpaceOnUse",
    x1: -120.227,
    y1: 104.3959,
    x2: -116.5841,
    y2: 104.3959,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129191565339466920280000006273150368365830278_)"
    },
    d: "M-118.9-60.8c-0.5-0.2-0.9-0.5-1.3-0.8 c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.5,0.3,0.7,0.4c0.3,0.2,0.5,0.2,0.7-0.1c0.4-0.7,0.9-1.4,1.4-2.1 c0.1-0.1,0.2-0.4,0.4-0.2c0.2,0.1,0.1,0.3,0,0.5c-0.5,0.8-1,1.5-1.5,2.3C-118.4-61-118.6-60.8-118.9-60.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147202473867082399150000014845710660259291791_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.0376,
    y1: 85.1186,
    x2: -121.7876,
    y2: 85.1186,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147202473867082399150000014845710660259291791_)"
    },
    d: "M-128.6-40.9c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1,0.2,0,0.4-0.1,0.5c0-0.7,0-1.4,0-2.1c0-0.7,0.2-1,0.8-1.2c1.3-0.5,2.4-1.2,3.8-1.5c0.9-0.2,1.8-0.3,2.7-0.2 c-0.2,0-0.5,0-0.8,0c0.3,0.3,0.6,0.2,0.8,0.4c-2-0.2-3.8,0.6-5.6,1.4c-1.2,0.6-1.2,0.3-1.2,1.8C-128.6-41.6-128.6-41.2-128.6-40.9z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016073573406258645760000004659549724371505038_",
    gradientUnits: "userSpaceOnUse",
    x1: -122.7142,
    y1: 82.9476,
    x2: -122.0722,
    y2: 82.9476,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016073573406258645760000004659549724371505038_)"
    },
    d: "M-122.1-41.3c0,0.1,0,0.1,0,0.2 c0,0.6,0,0.6-0.6,0.5C-122.1-40.5-122.2-41-122.1-41.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111878841491902820750000007358030680074551743_",
    gradientUnits: "userSpaceOnUse",
    x1: -66.5606,
    y1: 43.1732,
    x2: -32.3006,
    y2: 43.1732,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111878841491902820750000007358030680074551743_)"
    },
    d: "M-32.3-2.2c0-1.6-1-2.5-2.6-2.5 c-0.3,0-0.6,0-0.9,0c-0.5,0.1-0.6-0.1-0.6-0.6c0-1.3,0-2.7,0-4c0-1.2-0.6-2-1.5-2.3c-0.5-0.1-0.9-0.2-1.4-0.1 c-0.4,0-0.5-0.1-0.5-0.5c0-0.7,0-1.5,0-2.2c0.2-1.9-1.2-2.8-2.7-2.7c-1.2,0.1-2.3,0-3.5,0c-0.5,0-0.6-0.1-0.6-0.6 c0.1-0.7-0.3-0.9-0.9-0.9c-1,0-2.1,0-3.1,0c-0.3,0-0.5-0.1-0.7-0.4c-1-1.5-2.9-1.5-3.8,0c-0.2,0.3-0.4,0.4-0.7,0.4c-1,0-2,0-3,0 c-0.8,0-1,0.2-1,1c0,0.4-0.1,0.5-0.5,0.5c-1.2,0-2.4,0-3.6,0c-1.8,0-2.6,0.8-2.6,2.6c0,4.5,0,8.9,0,13.4s0,8.9,0,13.4 c0,1.7,0.9,2.6,2.6,2.6c4.8,0,9.5,0,14.3,0c0.7,0,1.3,0,1.5,0.7c0.1,0.2,0.4,0.4,0.6,0.5c0.4,0.2,0.5,0.4,0.5,0.9c0,0.5,0.1,1,0.7,1 c0.6,0,0.8-0.4,0.7-1c0-0.4,0.1-0.5,0.5-0.5c3,0,6,0,9,0c0.4,0,0.6,0,0.6,0.5c-0.1,0.5,0.1,1,0.7,1c0.6,0,0.8-0.4,0.8-1 c0-0.4,0.1-0.7,0.5-0.9c0.8-0.4,1.2-1.1,1.2-2c0-0.4,0-0.8,0-1.2C-32.3,7.8-32.3,2.8-32.3-2.2z M-38-4.9c-0.3,0.4-1.2,0.1-1.8,0.1 c-0.2,0-0.5,0-0.7,0c-0.7,0-1.4,0-2.1,0c-0.4,0-0.5-0.1-0.5-0.5c0.1-0.7-0.3-1.6,0.1-2c0.4-0.4,1.3-0.1,1.9-0.1c0.9,0,1.8,0,2.7,0 c0.3,0,0.5,0.1,0.5,0.5c0,0,0,0.1,0,0.1C-37.9-6.2-37.7-5.3-38-4.9z M-37.9-2.9c0,0.6-0.1,1.1-0.8,1.1c-0.6,0-1.2,0-1.9,0 c-0.6,0-1.1,0-1.7,0c-0.7,0-1.1-0.7-0.8-1.3c0.1-0.3,0.3-0.1,0.5-0.1c1.3,0,2.6,0,3.9,0C-38.4-3.2-37.9-3.5-37.9-2.9z M-38.9-10.3 c0.5,0,0.9,0.1,1,0.7c0.1,0.5,0,0.9-0.6,0.8c-0.6-0.1-1.3,0-1.9,0c-0.6,0-1.3,0-1.9,0c-0.2,0-0.7,0.2-0.7-0.3c0-0.4-0.1-0.9,0.5-1.1 c0.3-0.1,0.5-0.1,0.8-0.1C-40.8-10.3-39.8-10.3-38.9-10.3z M-56.7-17.2c0.6,0,1.2,0,1.9,0c0.5,0,0.9-0.2,0.9-0.7 c0-0.4,0.3-0.8,0.8-0.7c0.4,0,0.7,0.3,0.7,0.7c0.1,0.6,0.4,0.8,1,0.8c1,0,2,0,3,0c0.4,0,0.5,0.1,0.5,0.4c0.1,1.8,0.1,1.8-1.7,1.8 c-1.2,0-2.4,0-3.6,0c-1.5,0-3.1,0-4.6,0c-0.4,0-0.6-0.1-0.6-0.5C-58.4-17.3-58.4-17.2-56.7-17.2z M-48.4-3.4 c-0.2,0.5-0.5,0.5-0.9,0.5c-2.1,0-4.2,0-6.2,0c-0.2,0-0.4,0-0.6,0c-0.4,0.1-0.8,0.3-0.7,0.8c0,0.5,0.3,0.7,0.8,0.7 c0.7,0,1.5,0,2.2,0c1.5,0,3,0,4.5,0c0.5,0,0.7,0.1,0.6,0.6c0,1.1,0,2.2,0,3.4c0,0.4-0.1,0.5-0.5,0.5c-2.1,0-4.2,0-6.3,0 c-0.2,0-0.5,0-0.7,0c-0.4,0.1-0.6,0.4-0.6,0.7s0.2,0.6,0.7,0.7c0.2,0,0.4,0,0.7,0c2.1,0,4.2,0,6.2,0c0.5,0,0.7,0.1,0.6,0.6 c0,1.1,0,2.2,0,3.3c0,0.5-0.2,0.6-0.6,0.6c-2.1,0-4.2,0-6.2,0c-0.2,0-0.5,0-0.7,0.1c-0.4,0.1-0.6,0.4-0.6,0.8c0,0.4,0.2,0.6,0.7,0.7 c0.2,0,0.5,0,0.7,0c2.1,0,4.2,0,6.2,0c0.5,0,0.7,0.1,0.6,0.6c0,0.7,0.2,1.6-0.1,2c-0.4,0.4-1.3,0.1-2,0.1c-4.3,0-8.6,0-12.9,0 c-1.3,0-1.4-0.1-1.4-1.4c0-4.4,0-8.8,0-13.2c0-4.4,0-8.8,0-13.2c0-1,0.2-1.2,1.2-1.2c1.2,0,2.4,0,3.6,0c0.3,0,0.5,0.1,0.5,0.4 c-0.2,2.1,0.5,1.8,1.9,1.8c3.5,0,6.9,0,10.3,0c1,0,1.2-0.2,1.2-1.2c0-1.1,0-1.1,1.1-1.1c1,0,1.9,0,2.9,0c1,0,1.2,0.2,1.2,1.2 c0,0.7,0,1.3,0,2c0,0.6-0.1,0.8-0.7,0.7c-0.4-0.1-0.8,0-1.2,0.2c-0.9,0.4-1.4,1-1.4,2c0,1.2,0,2.4,0,3.6c0,1.3,0,1.3-1.4,1.3 c-0.3,0-0.6,0-0.9,0.1C-47.5-4.5-48.1-4.1-48.4-3.4z M-33.8,5.9c0,2.6,0,5.2,0,7.8c0,1-0.3,1.2-1.2,1.2c-3.6,0-7.3,0-10.9,0 c-0.9,0-1.2-0.3-1.2-1.2c0-5.3,0-10.5,0-15.8c0-0.9,0.3-1.2,1.2-1.2c0.1,0,0.1,0,0.2,0c1.1,0,1.1,0,1.2,1.1c0.1,1.1,1,1.9,2.1,1.9 c1.3,0,2.6,0,3.9,0c1.2,0,2.1-1,2.2-2.4c0-0.5,0.2-0.7,0.7-0.6c0,0,0.1,0,0.2,0c1.7,0,1.8,0.1,1.8,1.7C-33.8,0.9-33.8,3.4-33.8,5.9z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079462217895845594370000015945019912838199968_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.8707,
    y1: 50.1198,
    x2: -46.4704,
    y2: 50.1198,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079462217895845594370000015945019912838199968_)"
    },
    d: "M-51.7-7.4c-1.4,0-2.8,0-4.2,0 c-0.5,0-1-0.1-1-0.8c0-0.6,0.5-0.7,1-0.7c2.8,0,5.6,0,8.4,0c0.5,0,1,0.1,1,0.8c0,0.6-0.4,0.8-1,0.8C-48.8-7.4-50.3-7.4-51.7-7.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129183779460452883430000001049799385311358114_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.8411,
    y1: 50.1024,
    x2: -58.351,
    y2: 50.1024,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129183779460452883430000001049799385311358114_)"
    },
    d: "M-62.1-8.8c0.2,0,0.5,0.1,0.6,0.3 c0.3,0.4,0.5,0.3,0.8,0c0.3-0.4,0.6-0.7,1-1c0.4-0.3,0.8-0.4,1.1,0c0.4,0.4,0.3,0.8-0.1,1.1c-0.6,0.6-1.2,1.2-1.8,1.8 c-0.4,0.4-0.8,0.4-1.2,0c-0.3-0.3-0.7-0.7-1-1c-0.2-0.2-0.2-0.5-0.1-0.8C-62.6-8.7-62.4-8.8-62.1-8.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029759630373902702760000016527085976509660346_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.8321,
    y1: 44.1468,
    x2: -58.3389,
    y2: 44.1468,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029759630373902702760000016527085976509660346_)"
    },
    d: "M-61.1-0.4c-0.5,0-1.8-1.2-1.8-1.7 c0-0.3,0.2-0.5,0.4-0.6c0.3-0.1,0.7-0.1,0.9,0.2c0.3,0.4,0.6,0.4,0.9,0c0.3-0.4,0.7-0.7,1.1-1c0.3-0.3,0.7-0.3,1,0 c0.3,0.3,0.3,0.6,0.1,0.9C-59.2-2-60-1.3-60.7-0.6C-60.8-0.4-60.9-0.4-61.1-0.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168106541488595068890000000722243569195614856_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.8471,
    y1: 38.1936,
    x2: -58.3482,
    y2: 38.1936,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168106541488595068890000000722243569195614856_)"
    },
    d: "M-61.1,3.9c0.5-0.5,0.9-1,1.3-1.5 c0.3-0.4,0.8-0.4,1.1-0.1c0.4,0.4,0.3,0.8-0.1,1.2c-0.6,0.6-1.2,1.2-1.8,1.8c-0.4,0.4-0.8,0.4-1.2,0C-62,5-62.3,4.7-62.6,4.4 c-0.4-0.4-0.4-0.7-0.1-1.1c0.4-0.4,0.8-0.3,1.1,0C-61.4,3.5-61.3,3.6-61.1,3.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134940815281043552470000002720474422596182969_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.8473,
    y1: 32.2316,
    x2: -58.347,
    y2: 32.2316,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134940815281043552470000002720474422596182969_)"
    },
    d: "M-61.1,9.8c0.4-0.5,0.8-0.9,1.2-1.4 c0.4-0.4,0.8-0.6,1.2-0.2c0.4,0.4,0.2,0.8-0.1,1.2c-0.6,0.6-1.2,1.1-1.7,1.7c-0.4,0.4-0.8,0.4-1.2,0c-0.3-0.3-0.6-0.6-0.8-0.8 c-0.4-0.4-0.4-0.8-0.1-1.1c0.4-0.4,0.8-0.3,1.1,0C-61.4,9.4-61.3,9.6-61.1,9.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112611559353164332490000006051042141107779980_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.9628,
    y1: 34.6795,
    x2: -43.4628,
    y2: 34.6795,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112611559353164332490000006051042141107779980_)"
    },
    d: "M-43.5,7.3c0,1.4,0,2.8,0,4.2 c0,0.5-0.2,1-0.8,1c-0.5,0-0.7-0.4-0.7-0.9c0-2.9,0-5.7,0-8.6c0-0.5,0.2-0.9,0.7-0.9c0.6,0,0.8,0.4,0.8,1 C-43.5,4.5-43.5,5.9-43.5,7.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163069282891652026730000000622109024668911536_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.2412,
    y1: 34.6697,
    x2: -39.7406,
    y2: 34.6697,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163069282891652026730000000622109024668911536_)"
    },
    d: "M-41.2,7.3c0-1.4,0-2.7,0-4.1 c0-0.6,0.1-1.1,0.8-1.1c0.7,0,0.7,0.5,0.7,1.1c0,2.8,0,5.5,0,8.3c0,0.5-0.1,1.1-0.7,1.1c-0.7,0-0.8-0.5-0.8-1.1 C-41.2,10.1-41.2,8.7-41.2,7.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134967004215019602780000005382191411280513706_",
    gradientUnits: "userSpaceOnUse",
    x1: -37.5161,
    y1: 34.6791,
    x2: -36.0161,
    y2: 34.6791,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134967004215019602780000005382191411280513706_)"
    },
    d: "M-36,7.3c0,1.4,0,2.8,0,4.2 c0,0.5-0.2,1-0.8,0.9c-0.5,0-0.7-0.4-0.7-0.9c0-2.9,0-5.7,0-8.6c0-0.5,0.2-0.9,0.8-0.9c0.6,0,0.8,0.4,0.7,0.9C-36,4.5-36,5.9-36,7.3 z"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 128,
    height: 128,
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\Prashant Pal\\\\\\\\Downloads\\\\\\\\itinerary (1).png",
    transform: "matrix(3.1994 0 0 3.1994 -515.0541 -605.0541)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176001005807952402210000017481312703333356957_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.4526,
    y1: 20.3649,
    x2: 35.5474,
    y2: 20.3649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176001005807952402210000017481312703333356957_)"
    },
    d: "M32.4,1.3c-1.2-0.1-2.2,0.2-3,1 c-0.3-0.7-0.8-1.1-1.6-1.1c-7.2,0-14.4,0-21.6,0c-1,0-1.7,0.6-1.7,1.7c0,9.8,0,19.6,0,29.5c0,0.2,0,0.4,0.1,0.5 C4.7,33.6,5.3,34,6.1,34c3.1,0,6.3,0,9.4,0c0.3,0,0.4,0.1,0.4,0.4c0,1,0,2,0,3c0,0.7,0.3,1.3,0.9,1.7c0.4,0.3,1,0.4,1.5,0.4 c3.8,0,7.7,0,11.5,0c0.1,0,0.3,0,0.4,0c1.2-0.1,2-1,2-2.2c0-0.5,0-1,0-1.4c0-2.8,0-5.7,0-8.5c0-1.1-0.7-2-1.7-2.1 c-0.5-0.1-0.5-0.3-0.5-0.6c0-0.4,0-0.8-0.3-1c-0.4-0.3-0.4-0.6-0.4-1c0-0.3,0.1-0.4,0.4-0.5c1.7-0.1,2.9-1.3,2.9-3 c0-0.4,0-0.7,0-1.1c0-1.7-1.2-2.9-2.9-2.9c-0.3,0-0.4-0.1-0.4-0.4c0-1,0-2,0-3.1c0-0.3,0.1-0.4,0.4-0.4c0.7,0,1.3,0,2,0 c0.5,0,0.8-0.2,0.9-0.7c0-0.2,0.1-0.3,0.2-0.4c0.8-1.2,1.6-2.3,2.3-3.5C36.3,4.4,34.8,1.5,32.4,1.3z M15.9,27.4c0,1.9,0,3.7,0,5.6 c0,0.3-0.1,0.4-0.4,0.4c-3.1,0-6.2,0-9.4,0c-0.8,0-1.1-0.3-1.1-1.1c0-4.9,0-9.8,0-14.7c0-4.8,0-9.7,0-14.5c0-1,0.3-1.3,1.2-1.3 c7.1,0,14.2,0,21.3,0c0.8,0,1.2,0.4,1.2,1c0,0.2-0.1,0.3-0.1,0.5c-0.5,1.1-0.5,2.1,0,3.2c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.8,0,1.6,0,2.4c0,0.2-0.1,0.3-0.3,0.3c-0.4,0-0.8,0-1.2,0c-1.6,0-2.8,1.1-2.9,2.6c-0.1,0.5-0.1,1.1,0,1.7 c0.2,1.5,1.3,2.5,2.8,2.6c0.4,0,0.9,0,1.3,0c0.2,0,0.3,0.1,0.3,0.3c0,1.2,0,2.3,0,3.5c0,0.2-0.1,0.3-0.3,0.3c-2.4,0-4.9,0-7.3,0 c-0.3,0-0.2-0.1-0.1-0.3c0.6-0.9,1.2-1.8,1.8-2.8c1-1.6,0.4-4.2-1.7-5.1c-1.4-0.6-3-0.3-4.1,0.9c-0.8,0.9-1.4,2.7-0.5,4.2 c0.7,1.2,1.5,2.3,2.2,3.4c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.4,0.3,0.6,0.7,0.7c0.2,0,0.4,0,0.6,0c2.7,0,5.4,0,8.1,0 c0.3,0,0.5,0.1,0.4,0.4c0,0.2,0,0.4,0,0.5c0,0.1,0,0.2-0.1,0.3c-0.4,0.2-0.6,0.6-0.6,1.1c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.3-0.2,0.2 c0,0-0.1,0-0.1,0c-0.3,0-0.7,0.1-0.9-0.1c-0.2-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,0,0,0,0,0 c0,0.3,0.1,0.7-0.1,0.8c-0.3,0.2-0.8,0.1-1.2,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0-0.5,0-0.7c0-0.6-0.5-1-1-1c-0.5,0-0.9,0.4-1,1 c0,0.3,0.1,0.6-0.1,0.8c-0.2,0.2-0.6,0-0.9,0.1c-0.4,0-0.5-0.1-0.5-0.5c0-0.1,0-0.3,0-0.5c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1 c0,0.2,0,0.4,0,0.6c0,0.2-0.1,0.3-0.2,0.3C16.6,25.4,15.9,26.2,15.9,27.4z M20,20.9c-0.2,0.3-0.4,0.3-0.6,0 c-0.8-1.2-1.6-2.4-2.3-3.6c-1.1-1.7,0.2-4.5,2.6-4.5c2.5,0,3.8,2.7,2.7,4.5C21.6,18.5,20.8,19.7,20,20.9z M26.1,25.5 c0,0.4,0,0.7,0,1.1c0,0.3-0.1,0.5-0.4,0.5c-0.3,0-0.4-0.2-0.4-0.5c0-0.7,0-1.5,0-2.2c0-0.3,0.1-0.4,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4 C26.2,24.7,26.1,25.1,26.1,25.5z M22,24.4c0-0.3,0.1-0.5,0.4-0.5c0.3,0,0.4,0.2,0.4,0.4c0,0.7,0,1.5,0,2.2c0,0.3-0.1,0.4-0.4,0.4 c-0.3,0-0.4-0.2-0.4-0.5c0-0.4,0-0.8,0-1.1C22,25.1,22,24.7,22,24.4z M19.4,25.5c0,0.4,0,0.8,0,1.1c0,0.2-0.1,0.4-0.4,0.4 c-0.3,0-0.4-0.2-0.4-0.4c0-0.8,0-1.5,0-2.3c0-0.3,0.1-0.4,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4C19.4,24.7,19.4,25.1,19.4,25.5z  M31.6,37.1c0,1.2-0.6,1.8-1.8,1.8c-2.9,0-5.9,0-8.8,0c-0.9,0-1.9,0-2.8,0c-1.1,0-1.7-0.6-1.7-1.7c0-2,0-4,0-6 c0-0.3,0.1-0.4,0.4-0.4c2.4,0,4.8,0,7.2,0c2.4,0,4.8,0,7.2,0c0.3,0,0.4,0.1,0.4,0.4C31.6,33.1,31.6,35.1,31.6,37.1z M30,26.7 c0-0.2,0-0.4,0-0.6c0-0.3,0.1-0.4,0.4-0.3c0.6,0.2,1,0.7,1.1,1.4c0,0.9,0,1.8,0,2.6c0,0.3-0.2,0.3-0.4,0.3c-1.1,0-2.3,0-3.4,0 c-1.2,0-2.5,0-3.7,0c-2.4,0-4.7,0-7.1,0c-0.5,0-0.5,0-0.5-0.5c0-0.8,0-1.6,0-2.4c0-0.7,0.5-1.3,1.1-1.4c0.3-0.1,0.4,0,0.4,0.3 c0,0.2,0,0.4,0,0.6c0.1,0.5,0.5,0.9,1,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.6,0.1-0.7c0.4-0.1,0.8-0.1,1.2,0 c0.1,0,0.1,0.1,0.1,0.2c0,0.2,0,0.4,0,0.6c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.3,1-0.9c0-0.2,0-0.5,0-0.7c0-0.2,0.1-0.3,0.3-0.3 c0,0,0.1,0,0.1,0c0.9,0,0.9,0,1,0.9c0.1,0.6,0.4,1,1,1c0.6,0,0.9-0.4,1-1c0,0,0-0.1,0-0.1c0-0.3-0.1-0.6,0.1-0.7 c0.3-0.2,0.7-0.1,1,0c0.2,0,0.2,0.1,0.2,0.3c0,0.2,0,0.5,0,0.7c0.1,0.5,0.5,0.9,1,0.9C29.6,27.6,30,27.3,30,26.7z M29.5,24.3 c0,0.7,0,1.5,0,2.2c0,0.3-0.1,0.5-0.4,0.4c-0.3,0-0.4-0.2-0.4-0.5c0-0.4,0-0.7,0-1.1c0-0.4,0-0.7,0-1.1c0-0.3,0.1-0.5,0.4-0.5 C29.4,23.9,29.5,24.1,29.5,24.3z M30.9,10.6c-1.2,0-2.4,0-3.6,0c-1.2,0-2,0.8-2.1,2c0,0.4,0,0.7,0,1.1c0.1,1.1,0.9,2,2,2 c0.8,0,1.6,0,2.5,0c1.4,0,2.3,1,2.4,2.4c0,0.5,0.1,1.1,0,1.6c-0.2,1-0.9,1.7-1.9,1.9c-0.2,0-0.4,0-0.5,0c-3,0-6,0-8.9,0 c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.3,0.5-0.3c1.3,0,2.6,0,4,0c1.6,0,3.1,0,4.7,0c1.5,0,2.3-0.8,2.3-2.3c0-0.3,0-0.7,0-1 c-0.1-1.1-0.9-1.9-2-1.9c-0.8,0-1.6,0-2.4,0c-1.4,0-2.4-1-2.4-2.4c0-0.5,0-0.9,0-1.4c0.2-1.1,1.1-1.9,2.1-1.9c1.2,0,2.5,0,3.7,0 c0.2,0,0.4,0,0.4,0.2C31.1,10.6,31,10.6,30.9,10.6z M28.8,13.2c0,0.5,0,1.1,0,1.6c0,0.2-0.1,0.3-0.3,0.3c-0.4,0-0.8,0-1.2,0 c-0.8,0-1.4-0.6-1.4-1.3c0-0.4,0-0.8,0-1.2c0.1-0.8,0.6-1.3,1.4-1.3c0.4,0,0.8,0,1.2,0c0.3,0,0.3,0.1,0.3,0.3 C28.8,12.1,28.8,12.6,28.8,13.2z M29.4,18.6c0-0.6,0-1.2,0-1.7c0-0.2,0.1-0.3,0.3-0.3c0.8,0,1.5,0.5,1.5,1.4c0,0.4,0,0.8,0,1.2 c0,0.8-0.6,1.4-1.4,1.4c-0.2,0-0.3-0.1-0.3-0.3C29.4,19.8,29.4,19.2,29.4,18.6z M29.4,7.8C29.4,7.8,29.4,7.8,29.4,7.8 c0.5,0.5,0.8,1.1,1.2,1.7c0.1,0.1,0,0.2-0.1,0.2c-0.3,0-0.6,0-0.9,0c-0.1,0-0.2-0.1-0.2-0.2C29.4,9,29.4,8.4,29.4,7.8z M34.4,6.5 c-0.7,1.1-1.5,2.2-2.2,3.3c-0.2,0.4-0.4,0.4-0.7,0c-0.8-1.2-1.6-2.3-2.3-3.6c-0.2-0.4-0.4-0.9-0.3-1.2c0-1.3,0.6-2.3,1.6-2.8 c1-0.6,2.1-0.5,3.1,0.1C34.9,3.3,35.4,5,34.4,6.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034775790796433458450000011141453693241879992_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6388,
    y1: 6.2663,
    x2: 26.1851,
    y2: 6.2663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034775790796433458450000011141453693241879992_)"
    },
    d: "M16.9,6.8c-2.8,0-5.6,0-8.4,0 c-0.1,0-0.3,0-0.4,0c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.1-0.5,0.4-0.5c0.1,0,0.2,0,0.3,0c5.7,0,11.4,0,17,0c0.1,0,0.3,0,0.4,0 c0.2,0.1,0.4,0.3,0.3,0.5c0,0.3-0.2,0.4-0.4,0.5c-0.1,0-0.3,0-0.4,0C22.5,6.8,19.7,6.8,16.9,6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084531436482588662630000000900388528774357670_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6378,
    y1: 9.8868,
    x2: 23.5919,
    y2: 9.8868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084531436482588662630000000900388528774357670_)"
    },
    d: "M15.6,10.4c-2.4,0-4.7,0-7.1,0 c-0.1,0-0.3,0-0.4,0c-0.3,0-0.4-0.2-0.4-0.5c0-0.3,0.1-0.4,0.4-0.5c0.1,0,0.3,0,0.4,0c4.8,0,9.5,0,14.3,0c0.1,0,0.1,0,0.2,0 c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.3,0.5-0.7,0.5C20.5,10.4,18.1,10.4,15.6,10.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139981174048989692540000013208449282773167801_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6352,
    y1: 22.8582,
    x2: 16.8972,
    y2: 22.8582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139981174048989692540000013208449282773167801_)"
    },
    d: "M12.3,23.4c-1.3,0-2.5,0-3.8,0 c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.6,0,0.8,0c2.4,0,4.7,0,7.1,0c0.1,0,0.3,0,0.4,0 c0.3,0.1,0.4,0.2,0.4,0.5c0,0.3-0.2,0.5-0.5,0.5c-0.2,0-0.3,0-0.5,0C14.7,23.4,13.5,23.4,12.3,23.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003816306546586205430000008986750497009623680_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6347,
    y1: 13.2049,
    x2: 14.8056,
    y2: 13.2049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003816306546586205430000008986750497009623680_)"
    },
    d: "M11.2,13.7c-1,0-1.9,0-2.9,0 c-0.4,0-0.7-0.2-0.7-0.5c0-0.3,0.2-0.5,0.7-0.5c1.9,0,3.9,0,5.8,0c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.2,0.5-0.7,0.5 C13.2,13.7,12.2,13.7,11.2,13.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005239990648580524110000008318539748928124311_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6348,
    y1: 16.2218,
    x2: 14.8058,
    y2: 16.2218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005239990648580524110000008318539748928124311_)"
    },
    d: "M11.2,16.7c-1,0-1.9,0-2.9,0 c-0.4,0-0.7-0.2-0.7-0.5c0-0.3,0.3-0.5,0.7-0.5c1.9,0,3.9,0,5.8,0c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.2,0.5-0.7,0.5 C13.2,16.8,12.2,16.7,11.2,16.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130616581395676189730000015262192844623521436_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6348,
    y1: 19.5405,
    x2: 14.8058,
    y2: 19.5405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130616581395676189730000015262192844623521436_)"
    },
    d: "M11.2,20.1c-1,0-1.9,0-2.9,0 c-0.4,0-0.7-0.2-0.7-0.5c0-0.3,0.3-0.5,0.7-0.5c1.9,0,3.9,0,5.8,0c0.4,0,0.7,0.2,0.7,0.5c0,0.3-0.2,0.5-0.7,0.5 C13.2,20.1,12.2,20.1,11.2,20.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121994283550643540830000014080829755301575070_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6348,
    y1: 25.8763,
    x2: 14.8139,
    y2: 25.8763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121994283550643540830000014080829755301575070_)"
    },
    d: "M11.2,26.4c-1,0-1.9,0-2.9,0 c-0.4,0-0.7-0.2-0.7-0.5c0-0.3,0.2-0.5,0.7-0.5c2,0,3.9,0,5.9,0c0.5,0,0.8,0.3,0.6,0.7c-0.1,0.3-0.3,0.4-0.6,0.4 C13.2,26.4,12.2,26.4,11.2,26.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036953487025512540590000012200938174829641658_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6348,
    y1: 29.1947,
    x2: 14.8049,
    y2: 29.1947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036953487025512540590000012200938174829641658_)"
    },
    d: "M11.2,29.7c-1,0-1.9,0-2.9,0 c-0.4,0-0.7-0.2-0.7-0.5c0-0.3,0.2-0.5,0.7-0.5c2,0,3.9,0,5.9,0c0.4,0,0.6,0.2,0.6,0.5c0,0.3-0.2,0.5-0.7,0.5 C13.2,29.7,12.2,29.7,11.2,29.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018955555552774780310000006612043800021941661_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.3143,
    y1: 34.8013,
    x2: 27.4429,
    y2: 34.8013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018955555552774780310000006612043800021941661_)"
    },
    d: "M27.4,34.8c0,0.7,0,1.3,0,2 c0,0.2,0,0.3,0,0.5c-0.1,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.5-0.6c0-0.6,0-1.2,0-1.7c0-0.4,0-0.7,0-1.1c0-0.3,0-0.5-0.4-0.5 c-0.5,0-0.7-0.6-0.3-0.9c0.3-0.3,0.6-0.7,1-1c0.4-0.3,0.9-0.1,1,0.5c0,0.4,0,0.9,0,1.3C27.4,34.1,27.4,34.4,27.4,34.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173130002628932320630000011974270444484122272_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.6708,
    y1: 34.8064,
    x2: 24.4511,
    y2: 34.8064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173130002628932320630000011974270444484122272_)"
    },
    d: "M24.4,33.3c0-0.8-0.6-1.5-1.5-1.5 c-0.3,0-0.5,0-0.8,0c-0.8,0-1.5,0.6-1.5,1.5c0,1,0,2,0,3c0,0.8,0.7,1.5,1.5,1.5c0.3,0,0.5,0,0.8,0c0.9,0,1.5-0.7,1.5-1.5 c0-0.5,0-1,0-1.5S24.5,33.8,24.4,33.3z M22.8,36.6c-0.9,0-0.9,0-0.9-0.8c0-0.7,0-1.5,0-2.2c0-0.4,0.1-0.5,0.5-0.5 c0.1,0,0.2,0,0.2,0c0.5,0,0.6,0.1,0.6,0.6c0,0.4,0,0.8,0,1.2c0,0.4,0,0.9,0,1.3C23.2,36.4,23.1,36.6,22.8,36.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116939490716388364560000003312170659786115745_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5103,
    y1: 15.8245,
    x2: 21.9346,
    y2: 15.8245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116939490716388364560000003312170659786115745_)"
    },
    d: "M19.7,13.6c-1.2,0-2.2,1-2.2,2.2 c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C21.9,14.6,20.9,13.6,19.7,13.6z M19.7,17.4c-0.9,0-1.6-0.7-1.6-1.6 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C21.3,16.7,20.6,17.4,19.7,17.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115477120944249809230000015013781431868739719_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7243,
    y1: 4.8982,
    x2: 34.0994,
    y2: 4.8982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C4D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E35E68"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115477120944249809230000015013781431868739719_)"
    },
    d: "M31.9,2.7c-1.3,0-2.2,0.9-2.2,2.2 c0,1.3,0.9,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C34.1,3.6,33.2,2.7,31.9,2.7z M31.9,6.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 c0.9,0,1.6,0.7,1.6,1.6C33.5,5.8,32.8,6.5,31.9,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHolidayItinerary);
export default __webpack_public_path__ + "static/media/icon-holiday-itinerary.a4d42b6cc96d73827c2e4324415b00ce.svg";
export { ForwardRef as ReactComponent };